<template>
	<v-table density="compact" class="text-body-medium bg-transparent">
		<thead>
			<tr>
				<th v-for="(column, index) in columns" :key="column.key">
					<div :class="['py-2 text-label-small text-uppercase font-weight-bold text-medium-emphasis', index ? 'px-2' : 'ps-4 pe-2', { 'text-end': column.end }]">{{ column.label }}</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<template v-for="productId in productIds" :key="productId">
				<template v-if="isNegoPhase(phase)">
					<PromoNegoRow :campaign="campaign" :offer="offer" :offer-ref="offerRef" :product-id="productId" />
					<PromoNegoRow v-if="hasFreeRow(productId)" :campaign="campaign" :offer="offer" :offer-ref="offerRef" :product-id="productId" free />
				</template>
				<template v-else>
					<PromoStatementRow :campaign="campaign" :offer="offer" :offer-ref="offerRef" :product-id="productId" />
					<PromoStatementRow v-if="hasFreeRow(productId)" :campaign="campaign" :offer="offer" :offer-ref="offerRef" :product-id="productId" free />
				</template>
			</template>
			<tr v-if="!productIds.length">
				<td :colspan="columns.length" class="text-center text-medium-emphasis">
					<div class="pa-4">{{ t(offerRef.offerKey ? 'PromoLocalOfferNoProduct' : 'PromoNoProductsPublished') }}</div>
				</td>
			</tr>
		</tbody>
	</v-table>
</template>

<script setup>
import { computed } from 'vue';
import { usePromoStep } from '@/composables/usePromoStep';
import { isNegoPhase } from '@/utils/domain/promo/promoPhase';
import { getOfferInfo, listedProductIds } from '@/utils/domain/promo/promoModel';
import { freeRowOf } from '@/utils/domain/promo/promoFree';
import PromoNegoRow from './PromoNegoRow.vue';
import PromoStatementRow from './PromoStatementRow.vue';

const props = defineProps({
	campaign: { type: Object, required: true },
	offer: { type: Object, required: true },
	offerRef: { type: Object, required: true },
	phase: { type: String, required: true },
});

const { snapshot, t } = usePromoStep();

const productIds = computed(() => listedProductIds(snapshot.value, props.campaign, props.offer, getOfferInfo(snapshot.value, props.offerRef.offerKey)));
const hasFreeRow = (productId) => !!freeRowOf(snapshot.value, props.offerRef, productId);

const columns = computed(() => {
	if (isNegoPhase(props.phase)) {
		return [
			{ key: 'product', label: t('Products') },
			{ key: 'negotiated', label: t('VolumeNego') },
			{ key: 'location', label: t('Location') },
			{ key: 'highlight', label: t('LocationHighlight') },
			{ key: 'additional', label: '' },
			{ key: 'value', label: `${t('ProductPrice')} · ${t('Value')}`, end: true },
			{ key: 'cart', label: '' },
		];
	}
	return [
		{ key: 'product', label: t('Products') },
		{ key: 'presence', label: t('IsPromoPresent') },
		{ key: 'stated', label: t('VolumeStated') },
		{ key: 'price', label: t('ProductPriceStated') },
		{ key: 'location', label: t('Location') },
		{ key: 'highlight', label: t('LocationHighlight') },
		{ key: 'additional', label: '' },
	];
});
</script>
